import { useMemo, useState } from "react";
import PropTypes from "prop-types";

import { strCode } from "../../../../../../consts";
import { changeHistoryTypes } from "../../../consts/changeHistoryTypes";
import { t } from "../../../../../../services";
import { arrayUtil } from "../../../../../../utils";
import { historyLogsParserUtils } from "../../../utils/historyLogsParserUtils";

import {
  FlexContainers,
  LogHistoryTable,
  Modal,
  WrapperContainer
} from "../../../../../../components";
import { LogsTableDropdown } from "./components/LogsTableDropdown/LogsTableDropdown";
import { HistoryLogsWrapper, Title } from "./styled";

const sortOptions = [
  {
    id: 0,
    value: strCode.OLDEST_FIRST_OPTION
  },
  { id: 1, value: strCode.LATEST_FIRST_OPTION }
];

export const HistoryLogsModal = ({ history = [], active, setActive }) => {
  const [sortOption, setSortOption] = useState(sortOptions[1]);

  const { userCreationLog, sorted: logs } = useMemo(() => {
    const userCreationLog = history.find((log) => log.type === changeHistoryTypes.userCreation);
    const logs = history.filter((log) => log.type !== changeHistoryTypes.userCreation);

    const sorted = arrayUtil.sortByKey(logs, "timestamp", sortOption.id);

    return { userCreationLog, sorted };
  }, [history, sortOption.id]);

  return (
    history.length && (
      <Modal
        id="history-logs-modal"
        title={t(strCode.HISTORY_TITLE)}
        active={active}
        setActive={setActive}>
        <HistoryLogsWrapper Container={FlexContainers.FlexColumnStart}>
          {!!userCreationLog && (
            <LogHistoryTable
              logs={[userCreationLog]}
              parseLogs={historyLogsParserUtils.parseLogs}
              getLogAction={historyLogsParserUtils.getLogAction}
            />
          )}

          {logs?.length ? (
            <>
              <WrapperContainer
                Container={FlexContainers.FlexRowBetween}
                width={"100%"}
                mt={16}
                mb={8}>
                <Title>{t(strCode.HISTORY_LOG_TITLE)}</Title>
                <LogsTableDropdown
                  id={"sort-options-dropdown"}
                  options={sortOptions}
                  selectedOption={sortOption}
                  onSelectOption={setSortOption}
                />
              </WrapperContainer>
              <LogHistoryTable
                logs={logs}
                parseLogs={historyLogsParserUtils.parseLogs}
                getLogAction={historyLogsParserUtils.getLogAction}
              />
            </>
          ) : null}
        </HistoryLogsWrapper>
      </Modal>
    )
  );
};

HistoryLogsModal.propTypes = {
  history: PropTypes.arrayOf(
    PropTypes.shape({
      timestamp: PropTypes.number.isRequired,
      adminEmail: PropTypes.string.isRequired,
      action: PropTypes.string.isRequired,
      type: PropTypes.string.isRequired
    }).isRequired
  ),
  active: PropTypes.bool.isRequired,
  setActive: PropTypes.func.isRequired
};
